import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import moment from 'moment';
import { customerResource } from '@/views/system/customerManage/request';
import detailModal from '../refundManage/detailModal.vue';
import { payInfoRefundList, refundCheck } from '../request1';
export default {
  components: {
    detailModal
  },
  data() {
    return {
      infoShow: false,
      form: {
        infoType: 'REFUND',
        customerId: undefined,
        orderNo: '',
        status: undefined
      },
      time: [],
      customerList: [],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '退款流水号'
        },
        dataIndex: 'payNo',
        key: 'payNo',
        align: 'center'
      }, {
        slots: {
          title: '订单号'
        },
        dataIndex: 'orderNo',
        key: 'orderNo',
        align: 'center'
      }, {
        slots: {
          title: '订单金额'
        },
        dataIndex: 'orderAmount',
        key: 'orderAmount',
        align: 'center'
      }, {
        slots: {
          title: '退款金额'
        },
        dataIndex: 'refundTotalAmount',
        key: 'refundTotalAmount',
        align: 'center'
      }, {
        slots: {
          title: '退款状态'
        },
        dataIndex: 'statusName',
        key: 'statusName',
        align: 'center',
        scopedSlots: {
          customRender: 'statusName'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 180
      }],
      detailVisible: false
    };
  },
  async created() {
    if (this.$store.state.user.accountInfo.tag) {
      await this.getCustomerList();
    }
    await this.searchFun();
  },
  computed: {
    defaultValue() {
      return [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')];
    }
  },
  methods: {
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    openChangeDate(status) {
      if (status) {
        this.time = [];
      }
    },
    // 导出时间change
    onChangeExportTime(date) {
      if (date.length) {
        let startIsToday = moment(this.time[0]).isSame(moment(), 'days') && moment(this.time[0]).isAfter(moment());
        let endIsToday = moment(this.time[1]).isSame(moment(), 'days') && moment(this.time[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.time[0] = moment();
            this.time[1] = moment();
          } else if (endIsToday) {
            this.time[1] = moment();
          }
        }
      }
    },
    disabledRangeTime(dates, type) {
      let hours = moment().hours(); //0~23
      let minutes = moment().minutes(); //0~59
      let seconds = moment().seconds(); //0~59
      //当日只能选择当前时间之后的时间点
      if (this.time[1] && moment(this.time[1]).date() === moment().date() && type === 'end' || this.time[0] && moment(this.time[0]).date() === moment().date() && type === 'start') {
        console.log(this.range(0, hours), this.range(0, minutes));
        return {
          disabledHours: () => this.range(hours + 1, 24),
          disabledMinutes: () => this.range(minutes + 1, 60),
          disabledSeconds: () => this.range(seconds + 1, 60)
        };
      }
      return {
        disabledHours: () => this.range(23, 23),
        disabledMinutes: () => this.range(59, 59),
        disabledSeconds: () => this.range(59, 59)
      };
    },
    disabledDate(current) {
      return current && moment().endOf('day') < current;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      if (this.time.length) {
        obj.createAt = this.time[0];
        obj.endAt = this.time[1];
      } else {
        obj.createAt = undefined;
        obj.endAt = undefined;
      }
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      payInfoRefundList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async getCustomerList() {
      this.customerList = await customerResource({});
      let arr = this.customerList.find(item => item.id == Number(sessionStorage.getItem('insuredHomeReFundId')));
      this.form.customerId = arr ? Number(sessionStorage.getItem('insuredHomeReFundId')) : this.customerList[0].id;
      sessionStorage.setItem('insuredHomeReFundId', this.form.customerId);
    },
    changeCustom() {
      sessionStorage.setItem('insuredHomeReFundId', this.form.customerId);
    },
    async onDetail(record) {
      const res = await refundCheck({
        customerId: record.customerId,
        payInfoId: record.id
      });
      this.detailVisible = true;
      this.$nextTick(() => {
        this.$refs.infoFrom.init(res);
      });
    },
    reset() {
      this.form.customerId = undefined;
      this.form.orderNo = '';
      this.form.status = undefined;
      this.time = [];
    }
  }
};